import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { APP_PATHS } from "../../../constants/paths";
import classes from "./PricedOrderListItem.module.css";

const PricedOrderListItem = (props) => {
  const { orderId } = props;

  return (
    <li className={classes["priced-order"]}>
      <Link
        to={APP_PATHS.PRICED_ORDER_ITEMS.url.replace(":orderId", orderId)}
        className={classes["priced-order__link"]}
      >
        <p className={classes["priced-order__link-text"]}>
          طلب رقم <span className="numeric-content">#{orderId}</span>
        </p>
        <span className={classes["priced-order__link-arrow"]} />
      </Link>
    </li>
  );
};

export default PricedOrderListItem;

PricedOrderListItem.propTypes = {
  orderId: PropTypes.number,
};
